export default {
  data(){
    return {
      showPopup: false,
    }
  },
  methods: {
    openPopup(){
      this.showPopup = true;
    },
    closePopup(){
      this.showPopup = false;
    }
  },
  mounted(){
    Event.$on('open-popup', () => {
      this.openPopup();
    });
    Event.$on('close-popup', () => {
      this.closePopup();
    });
  }
};
